export const mainCta = {
  mainSite: "https://kaspreadsheet.com",
  mainSiteLabel: "AllChinaBuy Spreadsheet",
  buyNowLabel: "Buy It Now",
};